import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExpensesService } from '../../services/expenses.service';
import { IExpenses } from '../../interfaces/expenses/iexpenses';
import { map } from 'rxjs';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { Filter } from '../../models/filter';

@Component({
  selector: 'split-filter-expense',
  templateUrl: './split-filter-expense.component.html',
  styleUrls: ['./split-filter-expense.component.scss']
})
export class SplitFilterExpenseComponent {

  public data: IFilterData[] = [];

  @Input() field!: string;
  @Input() label!: string;
  @Input() key!: string;

  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();

  private filter = new Filter();

  constructor(private expenseService: ExpensesService) {

  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    let filter = this.filter.convertFilterInQuery();
    this.expenseService.getAll(filter).pipe(
      map((expenses: IExpenses[]) => expenses.map(expense => ({ name: expense.name, id: expense.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        this.data = data;
      }
    )
  }

  onSearchDropdownChange($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.load();
  }




}
